export default {
    BASE_URL: '/pub/file',
    api: [
      {
        name: 'list',
        method: 'GET',
        desc: '获取文件列表',
        path: '/selectList'
      },
      {
        name: 'delete',
        method: 'POST',
        desc: '删除上传文件',
        path: '/deleteByKey'
      }
    ]
  }
  


// WEBPACK FOOTER //
// ./src/api/apis/cms/file.js